const Images = {
  // Text Input
  logo: "/images/logo.png",
  error: "/images/error.svg",
  netflix: "/images/netflix.png",
  twitter: "/images/twitter.png",
  splunk: "/images/splunk.png",
  delta: "/images/delta.png",
  cbre: "/images/cbre.png",
  bms: "/images/bms.png",
  brookfield: "/images/brookfield.png",
  rekom: "/images/rekom.png",
  verizon: "/images/verizon.svg",
  okta: "/images/okta.png",
  medallia: "/images/medallia.svg",
  density: "/images/density.png",
  demo: "/images/demo.png",
};

export default Images;
